import { Heading, Text } from '@iguanads/react'
import { Helmet } from 'react-helmet-async'

export function ExpiredLink() {
  return (
    <>
      <Helmet title="Expired Link" />
      <main className="bg-grayscale-lightest dark:bg-grayscale-darker flex min-h-dvh flex-col items-center justify-center px-4">
        <div className="flex max-w-md flex-col items-center gap-4 text-center">
          <Heading size="h4">Link expired</Heading>
          <Text size="body-lg" className="text-grayscale-gray">
            This link has expired. Please open the order again from the app.
          </Text>
        </div>
      </main>
    </>
  )
}
